import React from "react"

import "./spinner.scss"

const Spinner = () => (
  <div className="spinner d-flex align-items-center justify-content-center">
    <h1>Loading...</h1>
  </div>
)

export default Spinner
